import { handleEnterPress } from "utils-lib/handleEnterPress"
import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

const SkipLinks = () => {
  const handleScroll = (elId) => {
    const el = ssrWindow.document.getElementById(elId)
    el.scrollIntoView({
      behavior: `smooth`,
      block: `start`,
    })
    setTimeout(() => {
      el.focus()
    }, 500)
  }

  return (
    <div id="skip-links" data-testid="SkipLinks">
      <button
        type="button"
        data-testid="SkipLinks - main button"
        aria-label="skip to main content"
        onKeyUp={(e) => {
          handleEnterPress(e, () => {
            handleScroll(`mainContent`)
          })
        }}
        onClick={() => {
          handleScroll(`mainContent`)
        }}
        className="skip-link d-inline-block position-absolute bg-white px-3 py-2 sr-only sr-only-focusable wm-link-grey-light"
        style={{ borderBottomRightRadius: `.5rem` }}
        tabIndex="-1"
      >
        skip to main content
      </button>
      <button
        type="button"
        data-testid="SkipLinks - footer button"
        aria-label="skip to footer"
        onKeyUp={(e) => {
          handleEnterPress(e, () => {
            handleScroll(`footerContent`)
          })
        }}
        onClick={() => {
          handleScroll(`footerContent`)
        }}
        className="skip-link d-inline-block position-absolute bg-white px-3 py-2 sr-only sr-only-focusable wm-link-grey-light"
        style={{ borderBottomRightRadius: `.5rem` }}
        tabIndex="-1"
      >
        skip to footer
      </button>
    </div>
  )
}

export default SkipLinks
